import store from "@/store"

export default async (to, from, next) => {
  // if there is a checkAuth flag on the route meta
  if (to.matched.some(record => record.meta.checkAuth)) {
    if (!store.getters["identity/getIsUserLoggedIn"]) {
      if (store.state["identity/authInProgress"] == true) {
        const unWatch = store.watch(
          (state, getters) => getters["identity/getIsUserLoggedIn"],
          newVal => {
            if (newVal) {
              unWatch()
              next()
            }
          },
          { immediate: true }
        )
      } else {
        try {
          await store.dispatch("identity/currentAuthenticatedUser")
          next()
        } catch (e) {
          store.commit("identity/SET_TOKEN", { JWT: null })
          next({ name: "Home" })
        }
      }
    } else {
      // user is 'logged in' but may need refreshed auth token
      // So get refreshed auth token OR properly log them out if refresh token has also expired
      try {
        await store.dispatch("identity/refreshCurrentUser")
        next()
      } catch (error) {
        console.error("BORK!", error)
        await store.dispatch("identity/identitySignOut")
        next({ name: "Home" })
      }
    }
  } else {
    next()
  }
}
